import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as c } from "../../../../IconBase-CxZyIWw2.js";
const r = l((e, s) => /* @__PURE__ */ o.jsx(
  c,
  {
    ref: s,
    ...e,
    image: (a) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...a,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M16.168 9.821c-.07-.46-.14-.92-.14-1.37C16.028 5.44 18.484 3 21.514 3S27 5.44 27 8.45s-2.456 5.452-5.486 5.452h-.043c-.442-.004-.892-.072-1.343-.14-.66-.1-1.323-.2-1.963-.097a2.28 2.28 0 0 0-1.458.876c-.902 1.19-.566 2.944-.276 4.459l.078.409q.12.644.12 1.323c0 4.014-3.274 7.268-7.314 7.268S2 24.746 2 20.732s3.275-7.268 7.315-7.268q.566.001 1.109.083l.369.057c1.635.255 3.574.557 4.756-.515a2.27 2.27 0 0 0 .715-1.307c.107-.638.005-1.3-.096-1.96M25 16a5 5 0 1 0 0 10 5 5 0 0 0 0-10",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
r.displayName = "RosaceaIcon";
export {
  r as RosaceaIcon,
  r as default
};
//# sourceMappingURL=index.js.map
